(function () {
  function initSkinConcernSearch() {
    var input = document.querySelector('[data-skin-concern-search]');
    var cards = document.querySelectorAll('[data-skin-concern-card]');

    if (!input || !cards.length) {
      return;
    }

    input.addEventListener('input', function () {
      var query = input.value.toLowerCase().trim();
      var visibleCount = 0;

      cards.forEach(function (card) {
        var searchText = card.getAttribute('data-search') || '';
        var matches = !query || searchText.indexOf(query) !== -1;

        card.hidden = !matches;

        if (matches) {
          visibleCount += 1;
        }
      });

      var emptyState = document.querySelector('[data-skin-concern-empty]');

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSkinConcernSearch);
  document.addEventListener('shopify:section:load', initSkinConcernSearch);
})();